const RESET_NOTIFICATIONS = (state) => {
  state.notificationsPage = 0
  state.notifications = null
  state.totalNotifications = null
  state.totalUnread = null
  state.noMoreNotifications = false
}

const NOTIFICATIONS_LOADING = (state) => {
  state.notificationsPage = 1
  state.notificationsLoading = true
  state.notificationsError = false
}

const NO_MORE_NOTIFICATIONS = (state) => {
  state.noMoreNotifications = true
  state.notificationsLoading = false
}

const NOTIFICATIONS_UPDATED = (state, notifications) => {
  state.notifications = notifications.notifications.sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  })
  state.totalNotifications = notifications.totalNotifications
  state.totalUnread = notifications.unRead
  state.notificationsLoading = false
}
const NOTIFICATIONS_ERROR = (state) => {
  state.notificationsLoading = false
  state.notificationsError = true
}

const NOTIFICATIONS_NEXT_PAGE_LOADING = (state) => {
  state.notificationsPage = state.notificationsPage + 1
  state.notificationsLoading = true
  state.notificationsError = false
}

const NOTIFICATIONS_NEXT_PAGE_UPDATED = (state, notifications) => {
  state.notifications = state.notifications.concat(notifications.notifications).sort((a, b) => {
    return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  })
  state.notificationsLoading = false
}

const NOTIFICATIONS_NEXT_PAGE_ERROR = (state) => {
  state.notificationsLoading = false
  state.notificationsError = true
}

export default {
  NOTIFICATIONS_LOADING,
  NOTIFICATIONS_UPDATED,
  NOTIFICATIONS_ERROR,
  RESET_NOTIFICATIONS,
  NO_MORE_NOTIFICATIONS,
  NOTIFICATIONS_NEXT_PAGE_LOADING,
  NOTIFICATIONS_NEXT_PAGE_UPDATED,
  NOTIFICATIONS_NEXT_PAGE_ERROR
}
